import { useEffect, useRef } from "react";

const supportsWebGL = () => {
  if (!window.WebGLRenderingContext) return false;
  try {
    const canvas = document.createElement("canvas");
    return !!(canvas.getContext("webgl2") || canvas.getContext("webgl"));
  } catch {
    return false;
  }
};

// Full-screen three.js layer for the hero blob, drawn above the page but ignoring clicks. Loaded lazily so it never blocks first paint;
// without WebGL the page keeps its CSS-only look.
export const Backdrop = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!supportsWebGL()) return;
    let dispose;
    let cancelled = false;
    const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

    import("../three/blobScene")
      .then(({ createBlobScene }) => {
        if (cancelled || !canvasRef.current) return;
        dispose = createBlobScene(canvasRef.current, { reducedMotion });
        document.documentElement.classList.add("webgl");
      })
      .catch((error) => console.warn("Backdrop: 3D scene unavailable", error));

    return () => {
      cancelled = true;
      if (dispose) dispose();
      document.documentElement.classList.remove("webgl");
    };
  }, []);

  return <canvas ref={canvasRef} className="bg-canvas" aria-hidden="true" />;
};
